up.compiler('.print-pdf', (element) => {
  let pdfObject = undefined;
  if(element.hasAttribute('pdf-base64')){
    pdfObject = element.getAttribute('pdf-base64');
  } else {
    pdfObject = document.getElementById(element.getAttribute('data-pdf-object-id'));
  }
  element.addEventListener('click', () => {
    if (pdfObject) {
      if (element.hasAttribute('pdf-base64')) {
        printJS({printable: pdfObject, type:'pdf',  base64: true});
      } else {
        printJS({printable: pdfObject.data, type:'pdf'});
      }
    } else {
      console.error('PDF object not found');
    }
  });
});
